"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function default_1(props) {
    var rectangle = props.rectangle, showLabel = props.showLabel, tagText = props.tagText;
    var boundingBoxStyle = {
        width: rectangle.width,
        height: rectangle.height,
        left: rectangle.x,
        top: rectangle.y,
    };
    return (react_1.default.createElement("div", { className: "eva-bounding-box", style: boundingBoxStyle }, showLabel && (react_1.default.createElement("div", { className: "eva-bounding-box-text-container" },
        react_1.default.createElement("span", { className: "eva-bounding-box-text" }, tagText)))));
}
exports.default = default_1;
